export default __webpack_public_path__ + "static/media/streak-77.46974cea.png";